import React from 'react';
import { IconTile } from '@atlaskit/icon';
import Page16Icon from '@atlaskit/icon-object/glyph/page/16';
import PageIcon from '@atlaskit/icon/core/page';
import { useIntl, type MessageDescriptor } from '@atlassian/jira-intl';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import messages from './messages.tsx';
import {
	StyledLink,
	CardWrapper,
	LeftWrapper,
	StyledTemplateName,
	RightWrapper,
	TryLozenge,
} from './styled.tsx';

type Props = {
	templateName: MessageDescriptor;
	requestStatusLozengeText: string;
	tenantIsOnFreeEdition: boolean;
	canProvisionConfluence: boolean;
	onClick?: (e: React.MouseEvent) => void;
	onClickCapture?: (e: React.MouseEvent) => void;
};

export const DummyConfluenceEntryPoint = ({
	templateName,
	requestStatusLozengeText,
	tenantIsOnFreeEdition,
	canProvisionConfluence,
	onClick,
	onClickCapture,
}: Props) => {
	const { formatMessage } = useIntl();

	return (
		<StyledLink
			onClick={onClick}
			onClickCapture={onClickCapture}
			data-testid="issue-view-base.content.confluence-placeholder-template-experiment.confluence-dummy-link.styled-link"
		>
			<CardWrapper>
				<LeftWrapper>
					{isVisualRefreshEnabled() ? (
						<IconTile icon={PageIcon} label="" appearance="blueBold" shape="square" size="16" />
					) : (
						<Page16Icon label="" />
					)}
					<StyledTemplateName>{formatMessage(templateName)}</StyledTemplateName>
				</LeftWrapper>
				<RightWrapper>
					<TryLozenge appearance="new">
						{tenantIsOnFreeEdition || canProvisionConfluence
							? formatMessage(messages.tryTemplateLozenge)
							: requestStatusLozengeText}
					</TryLozenge>
				</RightWrapper>
			</CardWrapper>
		</StyledLink>
	);
};
